import { defineRule } from "vee-validate";

defineRule("confirmed", (value, [target]) => {
    if (value === target) {
        return true;
    }
    return "Passwords must match";
});

// Nullable rule
defineRule("nullable", (value) => {
    return true;
});




// Email or Dynamic placeholder
defineRule("emailOrDynamic", (value) => {
    // Field is empty; let other rules handle required status if needed.
    if (!value) {
      return true;
    }
  
    // Regular expression for validating an email.
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
    // Regular expression for validating a dynamic tag enclosed in curly braces.
    // This pattern accepts one or more word characters (letters, digits, or underscores)
    // between a starting "{" and an ending "}".
    const dynamicPattern = /^\{\w+\}$/;
  
    // If the value matches either pattern, it's considered valid.
    if (emailPattern.test(value) || dynamicPattern.test(value)) {
      return true;
    }
  
    return "This field must be a valid email or a dynamic tag enclosed in curly braces.";
  });




  // Allow multiple emails or dynamic tags separated by commas
  defineRule("multipleEmailOrDynamic", (value) => {
    // Allow empty values and let required rule handle emptiness.
    if (!value) {
      return true;
    }
  
    // Regular expression for validating a standard email.
    const emailPattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  
    // Regular expression for validating a dynamic tag enclosed in curly braces.
    // Matches a string starting with '{', ending with '}', and containing one or more word characters.
    const dynamicPattern = /^\{\w+\}$/;
  
    // Split the input by commas and trim any whitespace from each segment.
    const entries = value.split(",").map((entry) => entry.trim()).filter(entry => entry !== "");
  
    // Loop through each entry and validate against email or dynamic tag pattern.
    for (const entry of entries) {
      if (!emailPattern.test(entry) && !dynamicPattern.test(entry)) {
        return "Each entry must be a valid email or a dynamic tag (e.g., {abc123}), separated by commas.";
      }
    }
  
    return true;
  });




// Number
defineRule("number", (value) => {
    if (value === undefined || value === null || value === "") {
        return true;
    }

    if (isNaN(value)) {
        return "This field must be a number";
    }

    return true;
});

defineRule("required", (value) => {
    if (value === 0) {
        return true;
    }
    if (!value) {
        return "This field is required";
    }

    if (Array.isArray(value) && value.length === 0) {
        return "You must choose at least one item";
    }

    return true;
});

defineRule("email", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if email

    const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!pattern.test(value)) {
        return "This field must be a valid email";
    }

    return true;
});

defineRule("boolean", (value) => {
    // If value is not provided, it's considered valid.
    // This is to avoid marking the field as invalid when it's not filled in.
    if (value === undefined || value === null || value === "") {
        return true;
    }

    // Check if the value is strictly true or false
    if (value === true || value === false) {
        return true;
    }

    return "This field must be a boolean (true or false).";
});

defineRule("phone", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern =
        /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;

    if (!pattern.test(value)) {
        return "This field must be a valid phone number";
    }

    return true;
});

defineRule("min", (value, [min]) => {
    if (!value) {
        return true; // let required rule handle empty values
    }

    if (String(value).length >= parseInt(min)) {
        return true;
    }

    return `This field must have minimum ${min} characters`;
});

// String
defineRule("string", (value) => {
    if (value === undefined || value === null || value === "") {
        return true;
    }

    if (typeof value === "string") {
        return true;
    }

    return "This field must be a string";
});

defineRule("max", (value, [max]) => {
    if (!value) {
        return true; // let required rule handle empty values
    }

    if (String(value).length <= parseInt(max)) {
        return true;
    }

    return `This field must have at most ${max} characters`;
});



defineRule("latitude", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern = /^[-]?(([0-8]?[0-9])\.(\d+))|(90(\.0+)?)$/;

    if (!pattern.test(value)) {
        return "This field must a valid longitude";
    }

    return true;
});

defineRule("longitude", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern = /^[-]?((((1[0-7][0-9])|([0-9]?[0-9]))\.(\d+))|180(\.0+)?)$/;

    if (!pattern.test(value)) {
        return "This field must a valid longitude";
    }

    return true;
});

defineRule("url", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/;

    if (!pattern.test(value)) {
        return "This field must a valid url";
    }

    return true;
});

defineRule("numeric", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern = /^[+-]?([0-9]+\.?[0-9]*|\.[0-9]+)$/;

    if (!pattern.test(value)) {
        return "This field must a valid number";
    }

    return true;
});

defineRule("price", (value) => {
    // Field is empty, should pass
    if (!value) {
        return true;
    }
    // Check if valid phone

    const pattern = /(\d+(?:\.\d+)?)/;

    if (!pattern.test(value)) {
        return "This must be a valid price";
    }

    return true;
});
